import { useState } from "react";
import Input from "./Input";

function PasswordField({ autoComplete = "current-password", ...props }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Input
      {...props}
      type={isVisible ? "text" : "password"}
      autoComplete={autoComplete}
      suffix={
        <button
          type="button"
          onClick={() => setIsVisible((currentValue) => !currentValue)}
          className="flex items-center justify-center text-slate-400 transition-colors hover:text-primary-600 focus:outline-none dark:text-slate-500"
        >
          {isVisible ? (
            <svg
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.815 7.815L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
              />
            </svg>
          ) : (
            <svg
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.036 12.322a1.012 1.012 0 010-.644C3.399 8.044 6.968 5 12 5c5.032 0 8.601 3.044 9.964 6.678.04.108.04.224 0 .332-1.363 3.634-4.932 6.678-9.964 6.678-5.032 0-8.601-3.044-9.964-6.678z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          )}
        </button>
      }
    />
  );
}

export default PasswordField;
